import { Modal } from "react-bootstrap";
import axios from 'axios';
import logo from '../logo.svg';
import logo2 from '../logo2.png';
import sellerlogo from '../user.webp';
import userlogo from '../user.webp';
import userlong from '../userlong.png';
import {Link} from 'react-router-dom';
import { ShoppingCart, Home, Cpu, Grid, User, HelpCircle, Power, Heart, CreditCard, LogIn, Monitor, Youtube, Briefcase, Shield, Phone, MessageCircle, AlignLeft, Package, DollarSign, Printer, Plus, FileText, Box, X, Percent, PhoneCall, GitMerge, Calendar, RotateCw, ExternalLink, Gift} from 'react-feather';
import { useContext, useState, useEffect } from 'react';
import { UserContext, CartContext, VendorContext } from '../context';
import { useLocation } from 'react-router-dom';
import Sidebar from './seller/sidebar';
import Sidebar0 from './customer/sidebar';
import Country from './country';
import Sidebar_bizdocs from './bizdocs/sidebar';
import { ExchangeRateContext } from '../ExchangeRateContext';
import { useSubscription } from "../useSubscription"; 
import useActiveVendor from "../useActiveVendor"; 
import api from "./api";
import { Link as ScrollLink } from 'react-scroll';
import { FaBriefcase, FaCashRegister, FaChalkboardTeacher, FaNetworkWired, FaRocket} from 'react-icons/fa';
import FooterSidebar from './footer-sidebar';
function Header({ activeShop }){
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl0 = process.env.REACT_APP_BASE_URL_IMG;

    const { exchangeRates, baseCurrency } = useContext(ExchangeRateContext);
    const userContext=useContext(UserContext);
    const vendorContext=useContext(VendorContext);  
    const {cartData,setCartData}=useContext(CartContext);    
    const [categories,setCategories]=useState([]);
    const [showSideCategories, setShowSideCategories] = useState(false);
    const [showSideCategories_dark, setShowSideCategories_dark] = useState(false);
    const [loadingCat, setLoadingCat] = useState(false);
    const location = useLocation();    
    const path = location.pathname;
    const [query, setQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const [VendorData, setVendorData] = useState(() => {
        const savedData = localStorage.getItem('VendorData');
        return savedData ? JSON.parse(savedData) : {
            'totalProducts': 0,
            'totalOrders': 0,
            'totalCustomers': 0,
            'name': '',
            'loc': '',
            'bal': '',
            'totalTraffic': '',
            'payMode': '',
            'payMode1': '',
            'payMode2': '',
        };
    });
    const [StoreStatusCheck, setStoreStatus] = useState('');
    const [showCreateModal, setShowCreateModal] = useState(false);
    var UserName=localStorage.getItem('customer_username');
    var VendorName=localStorage.getItem('vendor_shopname');
    const {
        packageDetails,
        isFree,
        isPremium,
        isGrowth,
        isLoading: subscriptionLoading
    } = useSubscription();
    
    const {
        vendorName: strnm0,
        vendorSlug: strnm
    } = useActiveVendor();

    if(cartData == null){
        var cartItems=0;
    }else{
        var cartItems=cartData.length;
    }
    
    const isCustPage = location.pathname.includes('/seller/' && !['/seller/login', '/seller/register']);  
    const isAHomeLink = ['/about', '/privacy', '/help-center'].some(path =>
        location.pathname.includes(path)
    ) || (location.pathname === '/terms');
    const isSellerPage = ['/seller/', '/affiliate'].some(path =>
        location.pathname.includes(path)
    );
    const isLoginPage = ['/login', 'seller/register', 'customer/register', 'reset-link', 'error404'].some(path =>
        location.pathname.includes(path)
    );

    const hideLogo = [
        //'/customer/' ,
        '/categories' ,
        '/seller/' ,
        '/seller/login' ,
        '/seller/register' ,
        '/seller/reset-link' ,
        //'/customer/login' ,
        //'/customer/register',
    ];

    const isLogoPage = hideLogo.some(
        path =>
            path === location.pathname 
    );
    
    var homeroute = ``;
    if(isAHomeLink){
        homeroute = `/`;
    }else{if(strnm !== null){homeroute = `${strnm}`;}}
    
    var popup_link_route_register = '/customer/register';
    var popup_link_route_login = '/customer/login';
    if(isSellerPage || isAHomeLink){popup_link_route_register = '/seller/register';popup_link_route_login = '/seller/login';}
    var show_search = '';
    if(isLoginPage){show_search="display-none";}
    
    const fetchData0 = async () => {
        try {
          const response = await api.get(`${baseUrl}/vendor-dashboard/`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("access_token")}`,
            },
          });
          setVendorData(response.data);
        } catch (err) {
          //console.error("Error fetching products:", err.toJSON());
        }
    };
    const fetchStoreStatus = async () => {
        try {
            const response = await api.get(`/${strnm}/status/`);
            setStoreStatus(response.data.package);

            // Redirect to shop suspended page if package is inactive
            //if (response.data.package_status === "inactive" || response.data.package_status === null) {
            //    navigate("/loader");
            //}
        } catch (error) {
            //console.error("Error fetching store status:", error);
        }
    };

     // Update localStorage whenever VendorData changes
     useEffect(() => {
        localStorage.setItem('VendorData', JSON.stringify(VendorData));
    }, [VendorData]);

    useEffect(() => {    
         
        if(isCustPage && localStorage.getItem("access_token") != null){
            fetchData0();
        }        
        if(strnm !== '' && strnm !== null){fetchStoreStatus();}
        fetchData(baseUrl+'/categories/');
    }, []);

    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        document.body.style.overflow = menuOpen ? "hidden" : "auto";
    }, [menuOpen]);

    useEffect(() => {
        const dropdowns = document.querySelectorAll('#navbarDropdown, #navbarDropdown1');

        if (!dropdowns.length) return;

        const handleShown = () => setMenuOpen(true);
        const handleHidden = () => setMenuOpen(false);

        dropdowns.forEach((dropdown) => {
            dropdown.addEventListener("shown.bs.dropdown", handleShown);
            dropdown.addEventListener("hidden.bs.dropdown", handleHidden);
        });

        return () => {
            dropdowns.forEach((dropdown) => {
                dropdown.removeEventListener("shown.bs.dropdown", handleShown);
                dropdown.removeEventListener("hidden.bs.dropdown", handleHidden);
            });
        };
    }, []);
    
    useEffect(() => {
        const fetchSuggestions = async () => {
          if (query.trim().length > 2) {
            const activeVendorName = strnm0;
    
            try {
              const response = await axios.get(
                `${baseUrl}/search/`,
                {
                    params: {
                      q: query,
                      vendor: activeVendorName || '',
                    },
                    headers: {
                      "Content-Type": "application/json",
                    },
                }
              );
              setSuggestions(response.data.products);
            } catch (error) {
              //console.error('Error fetching suggestions:', error);
              setSuggestions([]);
            }
          } else {
            setSuggestions([]);
          }
        };
    
        // Debounce API call (wait 300ms after typing stops)
        const timer = setTimeout(() => fetchSuggestions(), 300);
    
        // Cleanup on unmount or when query changes
        return () => clearTimeout(timer);
      }, [query]);
    
    useEffect(() => {
        const fetchCategories = async () => {
            setLoadingCat(true);
            const storedData = localStorage.getItem('categoriesData');
            const lastUpdated = localStorage.getItem('categoriesLastUpdated');

            // Check if data is already stored and it's less than 24 hours old
            if (storedData && lastUpdated) {
                const now = new Date().getTime();
                if (now - lastUpdated < 24 * 60 * 60 * 1000) {
                    setCategories(JSON.parse(storedData));
                    setLoadingCat(false);
                    return; // Use stored data without making a new fetch
                }
            }

            // Fetch new data if 24 hours have passed or data is not available
            try {
                const response = await api.get(baseUrl+'/categories', {
                    headers: {
                      Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    },
                  });
                const data = response.data.results;

                // Save data and timestamp to localStorage
                localStorage.setItem('categoriesData', JSON.stringify(data));
                localStorage.setItem('categoriesLastUpdated', new Date().getTime());

                setLoadingCat(false);
                setCategories(data);
            } catch (error) {
                setLoadingCat(false);
                //console.error('Error fetching categories:', error);
            }
        };

        
        if(isCustPage && localStorage.getItem("access_token") != null){
            fetchCategories();
        }
        pagereload();
    }, [location]);

    function pagereload(){
        const reloadCount = sessionStorage.getItem('reloadCount');
        if(reloadCount < 1) {
          sessionStorage.setItem('reloadCount', String(reloadCount + 1));
          window.location.reload();
        } else {
          sessionStorage.removeItem('reloadCount');
        }
      }

    function fetchData(baseurl){
        fetch(baseurl)
        .then((response) => response.json())
        .then((data) => {
            setCategories(data.results);
        });
    }
    function close(){
        setShowSideCategories(!showSideCategories);
        setShowSideCategories_dark(!showSideCategories_dark);
    };
    function open(){
        setShowSideCategories(!showSideCategories);
        setShowSideCategories_dark(!showSideCategories_dark);
    };
    var hideClassA = '';var hideClassB = '';
    if(vendorContext == 'true' || userContext == 'true') {
        hideClassA="hidenav0";
        hideClassB="";
    } else {
        hideClassA="";
        hideClassB="hidenav0";
    }
    var btnmnavvar="";
    const isHomePage =
    location.pathname === '/' ||
    location.pathname === '' ||
    location.pathname.includes('revenue-protection') ||
    location.pathname.includes('link-in-bio') ||
    location.pathname.includes('pricing') ||
    location.pathname.includes('careers') ||
    location.pathname.includes('affiliate') ||
    location.pathname.includes('help-center') ||
    location.pathname.includes('about') ||
    location.pathname === '/terms' || 
    location.pathname.includes('privacy') ||    
    location.pathname.includes('sales-customer-capture') ||    
    location.pathname.includes('customer-memory') ||
    location.pathname.includes('ai-relationship-messaging') ||
    location.pathname.includes('payments') ||
    location.pathname.includes('repeat-revenue-agent') ||
    location.pathname.includes('maeven') ||    
    location.pathname.includes('woocommerce-plugin');

    const isBizDocsPage = location.pathname.includes('bizdocs');   
    const isBizDocsPage0 = location.pathname.includes('/get');  
    if (isBizDocsPage === true) {btnmnavvar="bizdocs";}    
    if (isBizDocsPage0 === true) {btnmnavvar="getquotation";}
    var homepage='bg-white border-nav';
    if(isHomePage){homepage="bg-blue border-0";}

    function newprice(price,currency){
        // Convert price from the product's original currency to the selected base currency
        const productExchangeRate = exchangeRates[currency] || 1;
        const baseExchangeRate = exchangeRates[baseCurrency] || 1;

        // Calculate the converted price
        const convertedPrice = ((price / productExchangeRate) * baseExchangeRate).toFixed(2);

        return convertedPrice;
    }
    const handleDropdownClose = () => {
    // ✅ Force React state
    setMenuOpen(false);

    // =========================
    // CLOSE DROPDOWN (DESKTOP)
    // =========================
    const dropdownToggle = document.querySelector('[data-bs-toggle="dropdown"][aria-expanded="true"]');
    if (dropdownToggle) {
        dropdownToggle.click();
    }

    // =========================
    // CLOSE MOBILE NAV
    // =========================
    const collapseToggle = document.querySelector('[data-bs-toggle="collapse"][aria-expanded="true"]');
    if (collapseToggle) {
        collapseToggle.click();
    }

    // ✅ HARD RESET SCROLL
    document.body.style.overflow = "auto";
};
    var hidebtmnav="hide";
    var hidetopnav="hide";
    const hideNav = location.pathname.includes("/conversation/assistant") ||  location.pathname.includes("/checkout");
    if (!hideNav && !isLoginPage){hidebtmnav="";}
    var hidechatspan="badge-retarget-blank";
    const hideChat = location.pathname.includes("/conversation/assistant");
    if (!hideChat){hidechatspan="badge-retarget";}
    
    // Detect if on a shop page (like /1899republiq)
    const isShopPage = /^\/[^/]+$/.test(location.pathname) && location.pathname !== '/';

    const isCustLogin = location.pathname.includes("/customer/login");

    // Detect if on a product page (/product/:slug/:id)
    const isProductPage = /^\/product\/[^/]+\/\d+$/.test(location.pathname);

    // Detect if current page is a product details page
    const isProductDetailsPage = /^\/product\/[^/]+\/\d+$/.test(location.pathname);

    const [menuOpenMobile, setMenuOpenMobile] = useState(false);

    const handleDropdownCloseMobile = () => {
        setMenuOpenMobile(false);

        const navbar = document.getElementById("navbarSupportedContent");
        if (navbar?.classList.contains("show")) {
            navbar.classList.remove("show");
        }
    };

    return (
        <nav className={`navbar ${homepage} fixed-top navbar-expand-lg nav-con`}>
        {isHomePage ? (
            <>
                <div className="container">
                    <Link className="nav-link logo me-4" aria-current="page" to="/"><img src={logo2} className="card-img-top" alt="..."/></Link>                     
                    <button
                        className="navbar-toggler border-0 text-white"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded={menuOpenMobile}
                        aria-label="Toggle navigation"
                        onClick={() => setMenuOpenMobile(!menuOpenMobile)}
                    >
                        {menuOpenMobile ? (
                            <X className="text-white" />
                        ) : (
                            <AlignLeft className="text-white" />
                        )}
                    </button>
                    <div className="collapse navbar-collapse w-100" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle bgbtna hidefocus" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <b>Product</b>
                                </a>
                                <ul className="dropdown-menu navdropdowndiv navftrs" aria-labelledby="navbarDropdown"> 
                                <div className='row p-0 m-0'>

                                    <div className='col-12 col-lg-4 br-10'>
                                    <ScrollLink 
                                        to="pos" 
                                        smooth={true} 
                                        duration={500} 
                                        offset={-100}
                                        onClick={handleDropdownClose}
                                        className="pointer text-dark drktxt p-0"
                                    >
                                        <div className="row navftrspd">
                                        <div className="col-auto p-0"><FaCashRegister /></div>
                                        <div className="col-10 text-left">
                                            <h5 className='font1'><b>Sales & Customer Capture</b></h5>
                                            <p className="font8 grey-text mb-0">
                                            Capture every sale, manage stock and build customer history.
                                            </p>
                                        </div>
                                        </div>
                                    </ScrollLink>
                                    </div>

                                    <div className='col-12 col-lg-4 br-10'>
                                    <ScrollLink 
                                        to="customer-memory" 
                                        smooth={true} 
                                        duration={500} 
                                        offset={-100} 
                                        onClick={handleDropdownClose}
                                        className="pointer text-dark drktxt p-0"
                                    >
                                        <div className="row navftrspd">
                                        <div className="col-auto p-0"><Calendar /></div>
                                        <div className="col-10 text-left">
                                            <h5 className='font1'><b>Customer Intelligence</b></h5>
                                            <p className="font8 grey-text mb-0">
                                           Kadhr remembers what every customer buys and loves.
                                            </p>
                                        </div>
                                        </div>
                                    </ScrollLink>
                                    </div> 

                                    <div className='col-12 col-lg-4 br-10'>
                                    <ScrollLink 
                                        to="messaging" 
                                        smooth={true} 
                                        duration={500} 
                                        offset={-100}
                                        onClick={handleDropdownClose}
                                        className="pointer text-dark drktxt p-0"
                                    >
                                        <div className="row navftrspd">
                                        <div className="col-auto p-0"><MessageCircle /></div>
                                        <div className="col-10 text-left">
                                            <h5 className='font1'><b>Natural Messaging at Scale</b></h5>
                                            <p className="font8 grey-text mb-0">
                                            Keep customers engaged with natural messages.
                                            </p>
                                        </div>
                                        </div>
                                    </ScrollLink>
                                    </div>

                                    <div className='col-12 col-lg-4 br-10'>
                                    <ScrollLink 
                                        to="reorder-agent" 
                                        smooth={true} 
                                        duration={500} 
                                        offset={-100}
                                        onClick={handleDropdownClose}
                                        className="pointer text-dark drktxt p-0"
                                    >
                                        <div className="row navftrspd">
                                        <div className="col-auto p-0"><RotateCw /></div>
                                        <div className="col-10 text-left">
                                            <h5 className='font1'><b>Repeat Revenue Agent</b></h5>
                                            <p className="font8 grey-text mb-0">
                                            Attract and Track returning customers and repeat revenue.
                                            </p>
                                        </div>
                                        </div>
                                    </ScrollLink>
                                    </div> 

                                    <div className='col-12 col-lg-4 br-10'>
                                    <ScrollLink 
                                        to="payments" 
                                        smooth={true} 
                                        duration={500} 
                                        offset={-100}
                                        onClick={handleDropdownClose}
                                        className="pointer text-dark drktxt p-0"
                                    >
                                        <div className="row navftrspd">
                                        <div className="col-auto p-0"><CreditCard /></div>
                                        <div className="col-10 text-left">
                                            <h5 className='font1'><b>Connected Payments</b></h5>
                                            <p className="font8 grey-text mb-0">
                                            Accept payments across all channels and link them to customers.
                                            </p>
                                        </div>
                                        </div>
                                    </ScrollLink>
                                    </div>                                       

                                    <div className='col-12 col-lg-4 br-10'>
                                    <ScrollLink 
                                        to="maeven" 
                                        smooth={true} 
                                        duration={500} 
                                        offset={-100} 
                                        onClick={handleDropdownClose}
                                        className="pointer text-dark drktxt p-0"
                                    >
                                        <div className="row navftrspd">
                                        <div className="col-auto p-0">
                                            <Cpu />
                                        </div>
                                        <div className="col-10 text-left">
                                            <h5 className="font9"><b className='badge-retarget shadow-none'>Mæven AI</b></h5>
                                            <p className="font8 grey-text mb-0">
                                            Chat your way to reports, rewards, and growth insights.
                                            </p>
                                        </div>
                                        </div>
                                    </ScrollLink>
                                    </div>

                                </div>
                                </ul>
                            </li>
                            <li className="nav-item pointer">
                                <ScrollLink 
                                    to="usecases" 
                                    smooth="true" 
                                    duration={500} 
                                    offset={-100} // adjust if you have a fixed header
                                    onClick={handleDropdownClose}
                                    className="nav-link text-white0 bgbtna"
                                ><b>Customers</b></ScrollLink>
                            </li>
                            <li className="nav-item pointer">
                                <Link 
                                    to="/pricing" 
                                    smooth="true" 
                                    duration={500} 
                                    offset={-100} // adjust if you have a fixed header
                                    onClick={handleDropdownClose}
                                    className="nav-link text-white0 bgbtna"
                                ><b>Pricing</b></Link>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle bgbtna hidefocus" href="#" id="navbarDropdown1" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <b>Resources</b>
                                </a>                                
                                <ul className="dropdown-menu navdropdowndiv p-3 navftrs" aria-labelledby="navbarDropdown1">
                                    <div className='row p-0 m-0'>       
                                        <div className='col-12 col-lg-4 br-10'>
                                        <Link to="/woocommerce-plugin" target='_blank' className="text-dark p-0">
                                            <div className="row navftrspd">
                                                <div className="col-auto p-0" ><GitMerge/></div>
                                                <div className="col-10 text-left">
                                                    <h5 className='font1'><b>Woocommerce Plugin</b></h5>
                                                    <p className="font8 grey-text mb-0">Seamlessly integrate kadhr with your WooCommerce Store.</p></div>
                                            </div>
                                        </Link></div>                                 
                                        <div className='col-12 col-lg-4 br-10'>  
                                                <div className="row navftrspd">
                                                    <div className="col-auto p-0" ><PhoneCall/></div>
                                                    <div className="col-10 text-left">
                                                        <h5 className='font1'><b>Contact Us</b></h5>
                                                        <div className="font8 grey-text mb-0">
                                                            <ul className="nav flex-column">
                                                                <li className="nav-item mb-2"><a href="https://wa.me/254794072134" rel="noreferrer" target='_blank' className="nav-link p-0 text-body-secondary">WhatsApp</a></li>
                                                                <li className="nav-item mb-2"><a href="https://mailto:hello@kadhr.com" rel="noreferrer" target='_blank' className="nav-link p-0 text-body-secondary">hello@kadhr.com</a></li>                                                                
                                                            </ul>    
                                                        </div></div>
                                                </div>
                                            </div>
                                        
                                        <div className='col-12 col-lg-4 br-10'>
                                        <Link to="/about" target='_blank' className="text-dark p-0">
                                            <div className="row navftrspd">
                                                <div className="col-auto p-0" ><FaRocket/></div>
                                                <div className="col-10 text-left">
                                                    <h5 className='font1'><b>About Kadhr</b></h5>
                                                    <p className="font8 grey-text mb-0">Turn one-time buyers into repeat customers.</p></div>
                                            </div>
                                        </Link></div>
                                        <div className='col-12 col-lg-4 br-10'>
                                        <Link to="/careers" target='_blank' className="text-dark p-0">
                                            <div className="row navftrspd">
                                                <div className="col-auto p-0" ><FaBriefcase/></div>
                                                <div className="col-10 text-left">
                                                    <h5 className='font1'><b>Careers</b></h5>
                                                    <p className="font8 grey-text mb-0">Join us in simplifying how emerging markets sell.</p></div>
                                            </div>
                                        </Link></div>
                                        <div className='col-12 col-lg-4 br-10'>
                                        <Link to="/help-center" target='_blank' className="text-dark p-0">
                                            <div className="row navftrspd">
                                                <div className="col-auto p-0" ><HelpCircle/></div>
                                                <div className="col-10 text-left">
                                                    <h5 className='font1'><b>Help Center</b></h5>
                                                    <p className="font8 grey-text mb-0">Got questions? We've got answers.</p></div>
                                            </div>
                                        </Link></div>
                                        <div className='col-12 col-lg-4 br-10'>
                                        <Link to="https://www.youtube.com/@kadhrafrica" target='_blank' className="text-dark p-0">
                                            <div className="row navftrspd">
                                                <div className="col-auto p-0" ><FaChalkboardTeacher/></div>
                                                <div className="col-10 text-left">
                                                    <h5 className='font1'><b>Tutorials</b></h5>
                                                    <p className="font8 grey-text mb-0">Learn cool stuff, build faster - Kadhr’s got your back.</p></div>
                                            </div>
                                        </Link></div>
                                    </div>
                                </ul>
                            </li>
                        </ul>
                        <form className="d-flex">
                            <Link to="/seller/login" className="text-white0"><button className="btn border-none me-2 text-white0 pl-0" type="submit"><b>Log in</b></button></Link>
                            <Link to="/seller/register" className="text-white"><button className="btn btn-dark br50r" type="submit">Create account</button></Link>
                        </form>
                    </div>
                </div>
            </>
        ) : (
            <>
                <div className={`container ${hideClassA}`}>                       
                        {!isLogoPage && strnm !==null && StoreStatusCheck !== "Personal" && <><Link className="nav-link logo1 homeroute-width pt-2" aria-current="page" to={homeroute}><span className="txtlogo font9">{strnm0}</span></Link></>}
                        {!isLogoPage && strnm !==null && StoreStatusCheck === "Personal" && <><Link className="nav-link logo homeroute-width" aria-current="page" to={homeroute}><span className="txtlogo font9">{strnm0}</span></Link></>}
                        {!isLogoPage && strnm == null && StoreStatusCheck === "Personal" && <><Link className="nav-link logo" aria-current="page" to={homeroute}><img src={logo} className="card-img-top" alt="..."/></Link></>}
                        {!isLogoPage && strnm == null && StoreStatusCheck === "" && <><Link className="nav-link logo" aria-current="page" to={homeroute}><img src={logo} className="card-img-top" alt="..."/></Link></>}
                        {isLogoPage && <><Link className="nav-link logo" aria-current="page" to={homeroute}><img src={logo} className="card-img-top" alt="..."/></Link></>}                  
                       
                    {btnmnavvar !== 'bizdocs' && !isLoginPage && 
                        <>
                            <input
                                type="search"
                                className={`form-control me-2 mbl-srch ${show_search}`}
                                placeholder="Search for products.."
                                value={query}
                                onChange={(e) => setQuery(e.target.value)}
                                aria-label="Search"
                            />
                            {/* Suggestions Dropdown */}
                            <ul className="suggestions-list hddsktp0">
                                {suggestions.length > 0 ? (
                                    suggestions.map((product) => (
                                        <li key={product.id}>
                                            <a href={`/product/${product.title}/${product.id}`} target="_blank" rel="noreferrer">
                                                <img
                                                    src={baseUrl0 + product.image}
                                                    alt={product.title}
                                                    className="suggestion-image"
                                                />
                                                <div className="suggestion-details">
                                                    <span className="suggestion-title">{product.title}</span>
                                                    <span className="suggestion-price">
                                                        <div className="row">
                                                            <div className="col-7">{product.category}</div>
                                                            <div className="col-5 p-0">
                                                                {baseCurrency} {newprice(product.price, product.currency)}
                                                            </div>
                                                        </div>
                                                    </span>
                                                </div>
                                            </a>
                                        </li>
                                    ))
                                ) : query?.trim().length > 2 && (
                                    <li>
                                        <div className="d-flex align-items-center p-2">
                                            <div className="suggestion-details w-100">
                                                <span className="suggestion-title">No products found</span>
                                                <span className="suggestion-price text-muted">
                                                    Try a different search term.
                                                </span>
                                            </div>
                                        </div>
                                    </li>
                                )}
                            </ul>
                        </>
                    }  
                    {btnmnavvar == 'bizdocs' && 
                        <><h6 className="pageheader-title m-0"><b>Smart Desk</b></h6></>
                    }               

                    <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
                        <ul className="navbar-nav ms-auto mb-4 mb-lg-0">                            
                                <form className="d-flex" role="search">
                                    <input
                                        type="search"
                                        className={`form-control me-2 ${show_search}`}
                                        placeholder="Search for products."
                                        value={query}
                                        onChange={(e) => setQuery(e.target.value)}
                                        aria-label="Search"
                                    /> 
                                    {/* Suggestions Dropdown */}
                                    <ul className="suggestions-list">
                                        {suggestions.length > 0 ? (
                                            suggestions.map((product) => (
                                                <li key={product.id}>
                                                    <a href={`/product/${product.title}/${product.id}`} target="_blank" rel="noreferrer">
                                                        <img
                                                            src={baseUrl0 + product.image}
                                                            alt={product.title}
                                                            className="suggestion-image"
                                                        />
                                                        <div className="suggestion-details">
                                                            <span className="suggestion-title">{product.title}</span>
                                                            <span className="suggestion-price">
                                                                <div className="row">
                                                                    <div className="col-7">{product.category}</div>
                                                                    <div className="col-5 p-0">
                                                                        {baseCurrency} {newprice(product.price, product.currency)}
                                                                    </div>
                                                                </div>
                                                            </span>
                                                        </div>
                                                    </a>
                                                </li>
                                            ))
                                        )  : query?.trim().length > 2 && (
                                            <li>
                                                <div className="w-100 text-center py-3">
                                                    <span className="suggestion-title">
                                                        No products found
                                                    </span>
                                                    <span className="suggestion-price text-muted">
                                                        Try a different search term.
                                                    </span>
                                                </div>
                                            </li>
                                        )}
                                    </ul>
                                </form>    
                            <li className="nav-item">
                                <button type="button" className="btn position-relative" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                    <User/>
                                </button>
                            </li> 
                            <li className="nav-item">
                                <Link to="/checkout"><button type="button" className="btn position-relative">
                                    <ShoppingCart/>
                                    <span className="position-absolute top-0 mt-2 start-100 translate-middle badge rounded-pill bg-danger">        
                                        {cartItems }  
                                    </span>
                                </button></Link>
                            </li>  
                            {!isProductPage && !isLoginPage && (
                                isShopPage || isCustLogin ? (
                                    <li
                                    className="nav-item pointer ms-2"
                                    data-bs-toggle="modal"
                                    data-bs-target="#exampleModal1"
                                    >
                                    <span className="nav-link"><Grid /></span>
                                    </li>
                                ) : (
                                    <li className="nav-item pointer ms-2" onClick={open}>
                                    <span className="nav-link"><Grid /></span>
                                    </li>
                                )
                            )}





                        </ul>
                    </div>
                </div>

                {userContext == 'true' &&           
                
                    <div className={'container dashnav'}>
                        <Link className="nav-link logo" aria-current="page" to={homeroute}><img src={logo} className="card-img-top" alt="..."/></Link>       
                        {btnmnavvar !== 'bizdocs' && 
                            <>
                                    <input
                                        type="search"
                                        className={`form-control me-2 mbl-srch ${show_search}`}
                                        placeholder="Search for products.."
                                        value={query}
                                        onChange={(e) => setQuery(e.target.value)}
                                        aria-label="Search"
                                    />
                                    {/* Suggestions Dropdown */}
                                    {query?.trim().length > 2 && (
                                        <ul className="suggestions-list hddsktp0">
                                            {suggestions.length > 0 ? (
                                                suggestions.map((product) => (
                                                    <li key={product.id}>
                                                        <a href={`/product/${product.title}/${product.id}`} target="_blank" rel="noreferrer">
                                                            <img
                                                                src={baseUrl0 + product.image}
                                                                alt={product.title}
                                                                className="suggestion-image"
                                                            />
                                                            <div className="suggestion-details">
                                                                <span className="suggestion-title">{product.title}</span>
                                                                <span className="suggestion-price">
                                                                    <div className="row">
                                                                        <div className="col-7">{product.category}</div>
                                                                        <div className="col-5 p-0">
                                                                            {baseCurrency} {newprice(product.price, product.currency)}
                                                                        </div>
                                                                    </div>
                                                                </span>
                                                            </div>
                                                        </a>
                                                    </li>
                                                ))
                                            ) : (
                                                <li>
                                                    <div className="d-flex align-items-center p-2">
                                                        <div className="suggestion-details w-100">
                                                            <span className="suggestion-title">
                                                                No products found
                                                            </span>
                                                            <span className="suggestion-price">
                                                                Try a different search term
                                                            </span>
                                                        </div>
                                                    </div>
                                                </li>
                                            )}
                                        </ul>
                                    )}
                            </>
                        }  
                        {btnmnavvar == 'bizdocs' && 
                            <><h6 className="pageheader-title m-0"><b>Smart Desk</b></h6></>
                        }

                        <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
                            <ul className="navbar-nav ms-auto mb-4 mb-lg-0">
                                <li className="nav-item dropdown dropdown-toggle pointer topnavusricon" data-bs-toggle="modal" data-bs-target="#exampleModal" aria-expanded="false">
                                    <img src={userlong} width='30' className='br-10 me-1'/>  <span className='tcone font8'>{UserName}</span>
                                </li>                                
                            </ul>
                        </div>
                    </div>
                }

                {vendorContext == 'true' &&           
                    
                    <div className={'container dashnav'}>
                            
                        {btnmnavvar !== 'bizdocs' && 
                            <>
                               <Link
                                    className="nav-link logo"
                                    aria-current="page"
                                    to="/seller/dashboard"
                                >
                                    <img
                                        src={logo}
                                        className="card-img-top"
                                        alt="Kadhr"
                                    />
                                </Link>

                                <ul className="navbar-nav hddsktp0 d-flex flex-row align-items-center gap-2 ms-auto">

                                    {isGrowth && (
                                        <li className="nav-item pointer chat-nav-link">
                                            <Link
                                                to="/conversation/assistant"
                                                onClick={handleDropdownClose}
                                                className="nav-link text-white0 px-3 py-2 rounded-pill chat-pill"
                                            >
                                                <span className={`${hidechatspan} font1`}>
                                                    Chat
                                                </span>
                                            </Link>
                                        </li>
                                    )}

                                    <li className="nav-item dropdown-toggle pointer hddsktp0 topnavusricon prfnamenav"
                                        data-bs-toggle="modal"
                                        data-bs-target="#exampleModal"
                                    >
                                        <img
                                            src={sellerlogo}
                                            width="29"
                                            className="br-10 me-1"
                                            alt="User"
                                        />
                                    </li>

                                </ul>
                            </>
                        }  
                        {btnmnavvar == 'bizdocs' && 
                            <>
                                <Link className="nav-link logo" aria-current="page" to="/bizdocs/dashboard"><img src={logo} className="card-img-top" alt="..."/></Link>
                                <h6 className="pageheader-title m-0 ms-3"><b>Smart Desk</b></h6>
                            </>
                        }

                        <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
                            <ul className="navbar-nav ms-auto mb-4 mb-lg-0">    
                                {isGrowth && 
                                    <>
                                        <li className={`nav-item pointer chat-nav-link`}>
                                            <Link 
                                                to="/conversation/assistant" 
                                                smooth="true" 
                                                duration={500} 
                                                offset={-100} // adjust if you have a fixed header
                                                onClick={handleDropdownClose}
                                                className="nav-link text-white0"
                                            ><span className={`${hidechatspan} ml-2 font1`}>Chat</span></Link>
                                        </li>
                                    </>
                                }                            
                                
                                <li className="nav-item dropdown dropdown-toggle pointer topnavusricon" data-bs-toggle="modal" data-bs-target="#exampleModal" aria-expanded="false">
                                    <img src={sellerlogo} width='30' className='br-10 me-1'/> <span className='tcone'>{VendorName}</span>
                                </li>                                
                            </ul>
                        </div>
                    </div>
                }   

                {btnmnavvar !== 'bizdocs'  && !isProductDetailsPage && 
                    <>
                        <div className={`row btm-nav ${hidebtmnav}`}>
                                <div className='col-3 p-0 btmnavcon dshbrd text-dark'><Link to={homeroute}>
                                    <div className='col-12'><Home/></div>
                                    <div className='col-12 pt-1 btmnavlabel'>Home</div></Link>
                                </div>
                                <div className='col-3 p-0 btmnavcon text-dark' data-bs-toggle="modal" data-bs-target="#exampleModal">
                                    <div className='col-12'><User/></div>
                                    <div className='col-12 pt-1 btmnavlabel'>Account</div>
                                </div>
                                <div className='col-3 p-0 btmnavcon shpngbg text-dark'><Link to="/checkout">
                                    <div className='col-12'>
                                            <ShoppingCart/>
                                            <span className="position-absolute top-0 mt-1 badge rounded-pill orange">        
                                                {cartItems }  
                                            </span>
                                    </div>
                                    <div className='col-12 pt-1 btmnavlabel'>Cart</div></Link>
                                </div>
                                {(isShopPage || isCustLogin) ? (
                                    <div
                                        className='col-3 p-0 btmnavcon text-dark'
                                        data-bs-toggle="modal"
                                        data-bs-target="#exampleModal1"
                                    >
                                        <div className='col-12'><Grid /></div>
                                        <div className='col-12 pt-1 btmnavlabel'>More</div>
                                    </div>
                                ) : (
                                    <div className='col-3 p-0 btmnavcon text-dark' onClick={open}>
                                        <div className='col-12'><Grid /></div>
                                        <div className='col-12 pt-1 btmnavlabel'>More</div>
                                    </div>
                                )}



                        </div>
                        
                        {vendorContext == 'true' && (
                            <>
                                <div className={`row btm-nav ${hidebtmnav}`}>
                                    {/* Home */}
                                    <div className="col p-0 btmnavcon dshbrd">
                                        <Link to="/seller/dashboard" className={`text-decoration-none ${path.includes("/dashboard") ? "text-primary font-bold" : "text-dark"}`}>
                                        <div className="col-12"><Home /></div>
                                        <div className="col-12 pt-1 btmnavlabel">Home</div>
                                        </Link>
                                    </div>

                                    {/* Account */}
                                    <div
                                        className="col p-0 btmnavcon text-dark"
                                        data-bs-toggle="modal"
                                        data-bs-target="#exampleModal"
                                    >
                                        <div className="col-12 text-dark"><User /></div>
                                        <div className="col-12 pt-1 btmnavlabel">Account</div>
                                    </div>

                                    {/* Create (popup trigger) */}
                                    <div className="col p-0 btmnavcon text-center">
                                        <div
                                            className="text-decoration-none text-dark"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => setShowCreateModal(true)}
                                        >
                                        <div
                                            className="d-flex flex-column align-items-center justify-content-center"
                                            style={{
                                            position: "relative",
                                            top: "-2em",
                                            background: "#0070ff",
                                            width: "70px",
                                            height: "70px",
                                            borderRadius: "50%",
                                            boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                            color: "white",
                                            margin: "0 auto",
                                            }}
                                        >
                                            <Plus size={22} />
                                        </div>
                                        </div>
                                    </div>

                                    {/* Orders */}
                                    <div className="col p-0 btmnavcon">
                                        <Link to="/seller/orders" className={`text-decoration-none position-relative ${path.includes("/orders") ? "text-primary font-bold" : "text-dark"}`}>
                                        <div className="col-12">
                                            <Gift />
                                            <span className="position-absolute top-0 mt-1 badge rounded-pill orange">
                                            {VendorData.totalOrders}
                                            </span>
                                        </div>
                                        <div className="col-12 pt-1 btmnavlabel">Orders</div>
                                        </Link>
                                    </div>

                                    {/* Analytics */}
                                    <div className="col p-0 btmnavcon text-dark" onClick={open}>
                                        <div className="col-12"><Grid /></div>
                                        <div className="col-12 pt-1 btmnavlabel">More</div>
                                    </div>
                                
                                </div>

                                {/* Create Popup Modal */}
                                <Modal
                                    show={showCreateModal}
                                    onHide={() => setShowCreateModal(false)}
                                    centered
                                    dialogClassName="bottom-sheet-modal"
                                    contentClassName="border-0 rounded-top-4"
                                >
                                <div className="p-3">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h5 className="m-0 fw-bold">Create</h5>
                                    <X
                                        onClick={() => setShowCreateModal(false)}
                                        className="pointer"
                                    />
                                    </div>

                                    <div className="list-group">
                                    <Link to="/seller/pos" onClick={() => setShowCreateModal(false)} className="list-group-item list-group-item-action d-flex align-items-center border-0">
                                        <FileText className="me-3 text-primary" />
                                        <div>
                                        <div className="fw-semibold">POS</div>
                                        <small className="text-muted">Create order now</small>
                                        </div>
                                    </Link>

                                    <Link to="/seller/search-product" onClick={() => setShowCreateModal(false)} className="list-group-item list-group-item-action d-flex align-items-center border-0">
                                        <Box className="me-3 text-primary" />
                                        <div>
                                        <div className="fw-semibold">Product</div>
                                        <small className="text-muted">Create new product</small>
                                        </div>
                                    </Link>

                                    <Link to="/seller/staff" onClick={() => setShowCreateModal(false)} className="list-group-item list-group-item-action d-flex align-items-center border-0">
                                        <FaNetworkWired size={23} className="me-3 text-primary" />
                                        <div>
                                        <div className="fw-semibold">Employee</div>
                                        <small className="text-muted">Create employee now</small>
                                        </div>
                                    </Link>

                                    <Link to="/seller/manage-offers" onClick={() => setShowCreateModal(false)} className="list-group-item list-group-item-action d-flex align-items-center border-0">
                                        <Percent className="me-3 text-primary" />
                                        <div>
                                        <div className="fw-semibold">Discount</div>
                                        <small className="text-muted">Create discount now</small>
                                        </div>
                                    </Link>
                                    </div>
                                </div>
                                </Modal>

                                {/* Bottom sheet animation */}
                                <style>
                                {`
                                    .bottom-sheet-modal .modal-dialog {
                                    margin: 0;
                                    position: fixed;
                                    bottom: 0;
                                    width: 100%;
                                    }
                                    .bottom-sheet-modal .modal-content {
                                    border-top-left-radius: 20px;
                                    border-top-right-radius: 20px;
                                    animation: slideUp 0.3s ease;
                                    }
                                    @keyframes slideUp {
                                    from { transform: translateY(100%); }
                                    to { transform: translateY(0); }
                                    }
                                    .pointer { cursor: pointer; }
                                `}
                                </style>
                            </>
                        )}

                    </>
                }
                {btnmnavvar === 'bizdocs' &&
                    <>
                        <div className={`row btm-nav`}>
                                <div className='col-3 p-0 btmnavcon dshbrd'><Link to="/bizdocs/dashboard">
                                    <div className='col-12'><Home/></div>
                                    <div className='col-12 pt-1'>Home</div></Link>
                                </div>
                                <div className='col-3 p-0 btmnavcon'><Link to="/bizdocs/products">
                                    <div className='col-12'><Package/></div>
                                    <div className='col-12 pt-1'>Products</div></Link>
                                </div>
                                <div className='col-3 p-0 btmnavcon'><Link to="/bizdocs/customers">
                                    <div className='col-12'><User/></div>
                                    <div className='col-12 pt-1'>Customers</div></Link>
                                </div>
                                <div className='col-3 p-0 btmnavcon' onClick={open}>
                                    <div className='col-12'><Grid/></div>
                                    <div className='col-12 pt-1'>More</div>
                                </div>
                        </div>
                    </>
                }
                

                {showSideCategories_dark && <div className='cover' onClick={close}></div>}
                {showSideCategories && <div className='sidebar-cat'>
                    <div className="col-12 cat_div"> 
                        <h3 className="mb-2">
                            <div className="row pt-2 pb-2 font-bold text-left pl-2">
                                <div className="col-12">
                                    <span className={`${hideClassB}`}>
                                        <Link
                                            to={`${VendorData.website}`}
                                            target="_blank"
                                            className="nav-link d-flex align-items-center justify-content-between p-2 rounded-3 bg-white text-decoration-none shadow-tile"
                                            style={{ maxWidth: "280px",marginLeft:"7%",marginTop:"3%" }}
                                            >
                                            {/* Left section */}
                                            <div className="d-flex align-items-center">
                                                
                                                {/* Icon */}
                                                <div
                                                className="d-flex align-items-center justify-content-center me-2"
                                                style={{
                                                    width: "36px",
                                                    height: "36px",
                                                    borderRadius: "5px",
                                                    background: "rgb(0, 48, 110)", // soft purple
                                                    color: "#fff",
                                                    fontWeight: "600"
                                                }}
                                                >
                                                {VendorName?.charAt(0)?.toUpperCase() || "A"}
                                                </div>
                        
                                                {/* Text */}
                                                <div className="lh-sm">
                                                <div style={{ fontSize: "0.8em", fontWeight: "800", color: "rgb(0, 48, 110)" }}>
                                                    {VendorName}
                                                </div>
                                                </div>
                                            </div>
                        
                                            {/* Right icon */}
                                            <div className="text-muted">
                                                <ExternalLink size={16} style={{ color: "rgb(0, 48, 110)" }}/>
                                            </div>
                                        </Link>
                                    </span>
                                    <span className={`${hideClassA} pt-1`}>Explore</span> 
                                </div>                                          
                            </div> 
                        </h3>       
                        <div className={`con-responsive sidebarcon ${hideClassA}`}> 
                            <FooterSidebar/>     
                        </div>    
                        <div className={`con-responsive sidebarcon ${hideClassB}`}>    
                            
                            {userContext === 'true' ? (
                                <Sidebar0 />
                            ) : vendorContext === true ? (
                                <Sidebar />
                            ) : btnmnavvar !== 'bizdocs' ? (
                                <Sidebar />
                            ) : (
                                <Sidebar_bizdocs />
                            )}

                            
                        </div>
                    </div>
                </div>}

                <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog mt70 wusrmodal">
                        <div className="modal-content">
                            <div className="modal-body pb-4">  
                                <ul className='p-0'>
                                {btnmnavvar !== 'bizdocs' &&
                                    <>
                                                    {userContext != 'true' && vendorContext != 'true' &&
                                                        <>
                                                                {!isShopPage && !isProductPage && !isCustLogin && (
                                                                    <Link to={popup_link_route_register} className="text-dark">
                                                                        <li className='p-2 hvr pointer'>
                                                                        <User className='me-2'/> Create account
                                                                        </li>
                                                                    </Link>
                                                                )}

                                                                <Link to={popup_link_route_login} className="text-dark">
                                                                    <li className='p-2 hvr pointer'>
                                                                        <LogIn className='me-2'/> Log in
                                                                    </li>
                                                                </Link>
                                                                <Link to="/help-center" className="text-dark"><li className='p-2 hvr pointer'><HelpCircle className='me-2'/> Help Center</li></Link>
                                                                <Link to="/" target='_blank' className="text-dark"><li className='p-2 hvr pointer'><CreditCard className='me-2'/> Start Selling</li> </Link> 
                                                                    
                                                        </>
                                                    }

                                                    {userContext == 'true' &&
                                                        <>           
                                                            <li>
                                                                <div className="row bg-white p-2 pointer" >
                                                                    <div className="col-1 col-lg-1 p-0"><div className="ord-img-usr"><img src={userlogo} className='w-100 h-100'/></div></div>
                                                                    <div className="col-8 p-0 p-topnavcon">
                                                                        <p className='m-0 p-topnav tcone'>{UserName}</p>
                                                                        <span className="badge rounded-pill bg-success-nw text-white mt-1">• Online</span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <hr/>
                                                            <Link to="/customer/dashboard" className="text-dark"><li className='p-2 hvr pointer'><Monitor className='me-2'/> Dashboard</li></Link>
                                                            <Link to="/customer/wishlist" className="text-dark"><li className='p-2 hvr pointer'><Heart className='me-2'/> Wishlist</li></Link>
                                                            <Link to="/" target='_blank' className="text-dark"><li className='p-2 hvr pointer'><CreditCard className='me-2'/> Start Selling</li> </Link> 
                                                            <Link to="https://www.youtube.com/@kadhrafrica" target='_blank' className="text-dark"><li className='p-2 hvr pointer'><Youtube className='me-2'/> Guide & Tutorials</li></Link>
                                                            <hr/>
                                                            <Link to="/help-center" className="text-dark"><li className='p-2 hvr pointer'><HelpCircle className='me-2'/> Help Center</li></Link>
                                                            <Link to="/customer/logout" className="text-dark"><li className='p-2 hvr pointer'><Power className='me-2'/> Logout</li></Link>
                                                        </>
                                                    }

                                                    {vendorContext == 'true' &&
                                                        <> 
                                                            <li>
                                                                <div className="row bg-white p-2 pointer" >
                                                                    <div className="col-1 col-lg-1 p-0"><div className="ord-img-usr"><img src={sellerlogo} className='w-100 h-100'/></div></div>
                                                                    <div className="col-8 p-0 p-topnavcon">
                                                                        <p className='m-0 p-topnav tcone'>{VendorName}</p>
                                                                        <span className="badge rounded-pill bg-success-nw text-white mt-1">• Online</span>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            <hr/>
                                                            <Link to="/seller/dashboard" className="text-dark"><li className='p-2 hvr pointer'><Monitor className='me-2'/> Dashboard</li></Link>    
                                                            <Link to="/seller/profile" className="text-dark"><li className='p-2 hvr pointer'><User className='me-2'/> Profile</li></Link>                                                                    
                                                            <Link to="/seller/dashboard-a" className="text-dark"><li className='p-2 hvr pointer'><DollarSign className='me-2'/> Affiliate Program</li></Link>                                                 
                                                            <Link to="/bizdocs/dashboard" className="text-dark display-none"><li className='p-2 hvr pointer'><Printer className='me-2'/> Smart Desk</li></Link>                                                                                               
                                                            <hr/>
                                                            <Link to="https://wa.me/254794072134" className="text-dark"><li className='p-2 hvr pointer'><Phone className='me-2'/> Contact Us</li></Link>  
                                                            <Link to="https://www.youtube.com/@kadhrafrica" target='_blank' className="text-dark"><li className='p-2 hvr pointer'><Youtube className='me-2'/> Guide & Tutorials</li></Link>
                                                            <Link to="/seller/help-center" className="text-dark"><li className='p-2 hvr pointer'><HelpCircle className='me-2'/> Help Center</li></Link>
                                                            <Link to="/seller/logout" className="text-dark"><li className='p-2 hvr pointer'><Power className='me-2'/> Logout</li></Link>
                                                        </>
                                                    }
                                    </>
                                }
                                {btnmnavvar == 'bizdocs' &&
                                    <>
                                            <Link to="/bizdocs/dashboard" className="text-dark"><li className='p-2 hvr pointer'><Monitor className='me-2'/> Home</li></Link>
                                            <Link to="/bizdocs/profile" className="text-dark"><li className='p-2 hvr pointer'><Briefcase className='me-2'/> Business Profile</li></Link>
                                            <Link to="/bizdocs/terms" className="text-dark"><li className='p-2 hvr pointer'><Shield className='me-2'/> Terms</li></Link>
                                            <Link to="https://wa.me/254794072134" className="text-dark"><li className='p-2 hvr pointer'><Phone className='me-2'/> Contact Us</li></Link>
                                            <hr/>
                                            <Link to="https://www.youtube.com/@kadhrafrica" target='_blank' className="text-dark"><li className='p-2 hvr pointer'><Youtube className='me-2'/> Guide & Tutorials</li></Link>
                                            <Link to="/help-center" className="text-dark"><li className='p-2 hvr pointer'><HelpCircle className='me-2'/> Help Center</li></Link>
                                            <Link to="/seller/logout" className="text-dark"><li className='p-2 hvr pointer'><Power className='me-2'/> Logout</li></Link>
                                    </>
                                }
                                                    
                                                    <hr/>
                                                    <li className='p-2 pointer mt-3'>
                                                        <h6>Currency</h6> 
                                                        <Country />
                                                    </li>
                                    
                                </ul> 
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )}

        </nav>      
    )
}

export default Header;